import {faBoxAlt} from "@fortawesome/pro-light-svg-icons/faBoxAlt";
import {faShoppingBasket} from "@fortawesome/pro-light-svg-icons/faShoppingBasket";
import {
    ARTICLE_CONFIGURATOR_MODE_CMS,
    ARTICLE_CONFIGURATOR_MODE_CONSUMER,
    ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION,
    ARTICLE_CONFIGURATOR_MODE_SHARED,
    ARTICLE_CONFIGURATOR_MODE_SHOP,
    ARTICLE_TYPE_BASE,
    ARTICLE_TYPE_CMS,
    ARTICLE_TYPE_DEV,
    ARTICLE_TYPE_SHOP,
    PROJECT_STATE_DEV,
    PROJECT_STATE_LIVE
} from "../constants/General";
import {getBaseArticle, getContracts, getMappings} from "../selectors/SimpleSelectors";
import {_account, _contract} from "../selectors/GetParam";
import {getCurrentAccountByContract} from "../selectors/Accounts";
import {delve} from "../util/util";
import {createSelector} from "reselect";

export const DOMAIN_AMOUNT_TOPDOMAINS = 10
export const DOMAIN_LOAD_MORE_AMOUNT = 10

export const agencyServerArticleNumber = "72000";
export const devProjectArticleNumber = "72002";

/** Article Mapping **/
export const cmsArticles = ["70000", "70010", "70001", "70011", "70012", "70002", "70013", "70014", "70003", "70015", "70016", "70004", /* HS: */  "70017", "70018", "70019"];
export const shopArticles = ["70500", "70510", "70501", "70511", "70512", "70502", "70513", "70514", "70503", "70515", "70516", "70504", /* HS: */  "70517", "70518", "70519"];
export const agencyServerCMSArticles = ["72100", "72101", "72111", "72112", "72102", "72113", "72114", "72103", "72115", "72116", "72104", /* HS: */ "72117", "72118", "72119"];
export const agencyServerShopArticles = ["72200", "72210", "72201", "72211", "72212", "72202", "72213", "72214", "72203", "72223", "72224", "72204", /* HS: */  "72225", "72226", "72227"];
export const agencyServerProjectArticles = ["696969", "72002", ...agencyServerCMSArticles, ...agencyServerShopArticles];
export const accessoryArticles = ["74000", "74011"/*, "74010"*/, "75000", "75001", "75002", "75003"];
export const dsgvoArticles = ["191021", "191025", "191026"];

export const lsConfigurator = "mw_configurator_0221"
export const lsPrefix = "mw_3.2_";

/** DYNAMIC API ENDPOINTS **/
export const cartApiEndpoint = process.env.NODE_ENV === 'development' ? 'carts' : 'carts';

export const getAvailableAccessoryArticles = createSelector(
    [
        getContracts,
        getMappings,
        getCurrentAccountByContract
    ], (
        contracts,
        mappings,
        currentAccount
    ) => {

    let availableAccessories = [...accessoryArticles];

    // search for already purchased accessories for current account
    const pNameMappings = mappings && mappings.pNameAccount || {};

    if (contracts && currentAccount) {
        Object.keys(contracts).forEach(contractIdentifier => {
            const contractData = contracts[contractIdentifier];
            const contractArticleNumber = ''+delve(contractData,'article.articleNumber');
            if(accessoryArticles.indexOf(contractArticleNumber) >= 0) {
                // is accessory
                const accountName = delve(contractData, 'account.name');
                if (accountName && pNameMappings[accountName] === '' + currentAccount) {
                    availableAccessories = availableAccessories.filter(accessory => accessory !== contractArticleNumber);
                }
            }
        })
    }

    return availableAccessories;
})


/** Article Configurator setup **/
export const getArticleConfiguratorData = (state) => {
    return {
        // 72000
        [ARTICLE_CONFIGURATOR_MODE_SHARED]: {
            projectStates: {
                [PROJECT_STATE_DEV]: {
                    label: "DEV-Projekt",
                    value: PROJECT_STATE_DEV,
                    projectTypes: {
                        dev: {
                            label: "DEV-Projekt",
                            value: ARTICLE_TYPE_DEV,
                            icon: faBoxAlt,
                            default: "72002",
                            articles: ["72002"]
                        }
                    }
                },
                [PROJECT_STATE_LIVE]: {
                    label: "LIVE-Projekt",
                    value: PROJECT_STATE_LIVE,
                    projectTypes: {
                        cms: {
                            label: "Website / Blog",
                            value: ARTICLE_TYPE_CMS,
                            icon: faBoxAlt,
                            default: "72111",
                            articles: [
                                "72100", "72101", "72111", "72112", "72102", "72113", "72114", "72103", "72115", "72116", "72104", "72117", "72118", "72119"
                            ]
                        },
                        shop: {
                            label: "Shop / E-Commerce",
                            value: ARTICLE_TYPE_SHOP,
                            icon: faShoppingBasket,
                            default: "72201",
                            articles: [
                                "72200", "72210", "72201", "72211", "72212", "72202", "72213", "72214", "72203", "72223", "72224", "72204", "72225", "72226", "72227"
                            ]
                        }
                    }
                },
            },
            backupRange: [
                {label: "1 Tag", value: 1},
                {label: "7 Tage", value: 7},
                {label: "14 Tage", value: 14},
                {label: "28 Tage", value: 28}
            ],
            initialValues: {
                state: "",
                article: "",
                type: "",
                backup: 0,
                storage: ""
            }
        },
        // 70500, etc...
        [ARTICLE_CONFIGURATOR_MODE_CMS]: {
            projectStates: {
                [PROJECT_STATE_LIVE]: {
                    label: "LIVE-Projekt",
                    value: PROJECT_STATE_LIVE,
                    projectTypes: {
                        cms: {
                            label: "Website / Blog",
                            value: ARTICLE_TYPE_CMS,
                            icon: faBoxAlt,
                            default: "70010",
                            articles: [
                                "70000", "70010", "70001", "70011", "70012", "70002", "70013", "70014", "70003", "70015", "70016", "70004", "70017", "70018", "70019"
                            ]
                        }
                    },
                }
            },
            backupRange: [
                {label: "1 Tag", value: 1},
                {label: "7 Tage", value: 7},
                {label: "14 Tage", value: 14},
                {label: "28 Tage", value: 28}
            ],
            initialValues: {
                state: "",
                article: "",
                type: "",
                backup: 0,
                storage: ""
            }
        },
        [ARTICLE_CONFIGURATOR_MODE_SHOP]: {
            projectStates: {
                [PROJECT_STATE_LIVE]: {
                    label: "LIVE-Projekt",
                    value: PROJECT_STATE_LIVE,
                    projectTypes: {
                        shop: {
                            label: "Shop / E-Commerce",
                            value: ARTICLE_TYPE_SHOP,
                            icon: faBoxAlt,
                            default: "70510",
                            articles: [
                                "70500", "70510", "70501", "70511", "70512", "70502", "70513", "70514", "70503", "70515", "70516", "70504", "70517", "70518", "70519"
                            ]
                        }
                    },
                }
            },
            backupRange: [
                {label: "1 Tag", value: 1},
                {label: "7 Tage", value: 7},
                {label: "14 Tage", value: 14},
                {label: "28 Tage", value: 28}
            ],
            initialValues: {
                state: "",
                article: "",
                type: "",
                backup: 0,
                storage: ""
            }
        },
        [ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION]: {
            projectStates: {
                [PROJECT_STATE_LIVE]: {
                    label: "LIVE-Projekt",
                    value: PROJECT_STATE_LIVE,
                    projectTypes: {
                        cms: {
                            label: "Website / Blog",
                            value: ARTICLE_TYPE_CMS,
                            icon: faBoxAlt,
                            default: "70010",
                            articles: [
                                "70000", "70010", "70001", "70011", "70012", "70002", "70013", "70014", "70003", "70015", "70016", "70004", "70017", "70018", "70019"
                            ]
                        },
                        shop: {
                            label: "Shop / E-Commerce",
                            value: ARTICLE_TYPE_SHOP,
                            icon: faShoppingBasket,
                            default: "70510",
                            articles: [
                                "70500", "70510", "70501", "70511", "70512", "70502", "70513", "70514", "70503", "70515", "70516", "70504", "70517", "70518", "70519"
                            ]
                        }
                    }
                }
            },
            backupRange: [
                {label: "1 Tag", value: 1},
                {label: "7 Tage", value: 7},
                {label: "14 Tage", value: 14},
                {label: "28 Tage", value: 28}
            ],
            initialValues: {
                state: "",
                article: "",
                type: "",
                backup: 0,
                storage: ""
            }
        },
        [ARTICLE_CONFIGURATOR_MODE_CONSUMER]: {
            projectStates: {
                [PROJECT_STATE_LIVE]: {
                    label: "LIVE-Projekt",
                    value: PROJECT_STATE_LIVE,
                    projectTypes: {
                        base: {
                            label: "Ihr gewählter Artikel",
                            value: ARTICLE_TYPE_BASE,
                            icon: faBoxAlt,
                            default: "" + getBaseArticle(state).articleNumber,
                            articles: [
                                // in this mode, only add base article as only option
                                "" + getBaseArticle(state).articleNumber
                            ]
                        }
                    }
                }
            },
            backupRange: [
                {label: "1 Tag", value: 1},
                {label: "7 Tage", value: 7},
                {label: "14 Tage", value: 14},
                {label: "28 Tage", value: 28}
            ],
            initialValues: {
                state: "",
                article: "",
                type: "",
                backup: 0,
                storage: ""
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/config/Config.js
 **/